import React from "react";
import T from "prop-types";

import { isEmpty } from "2g-utils-common";
import { PlaceholderText } from "2g-placeholder";
import { PageMessageEmpty } from "2g-page-message";

import { useMessagesGlobal } from "b2b/i18n";

import mockData from "b2b-devel/rezervace.json";
import { RezervaceTableContentTable } from "./RezervaceTableContentTable";

export function RezervaceTableContent({ zdroje, dny, loading }) {
  const messagesGlobal = useMessagesGlobal();

  const TextComponent = loading ? PlaceholderText : React.Fragment;

  if (loading) {
    zdroje = mockData.zdroje;
    dny = mockData.dny;
  }

  return !loading && (isEmpty(zdroje) || isEmpty(dny)) ? (
    <PageMessageEmpty message={messagesGlobal.messageEmptyItems()} />
  ) : (
    <div className="b2b-RezervaceTableContent">
      <RezervaceTableContentTable
        textComponent={TextComponent}
        zdroje={zdroje}
        dny={dny}
      />
    </div>
  );
}

RezervaceTableContent.propTypes = {
  loading: T.bool,
  dny: T.array,
  zdroje: T.array
};

export default React.memo(RezervaceTableContent);
